let network = () => {
  const href = location.href;

  if (/local|localhost/i.test(href)) {
    return 'local';
  }
  if (/opdev|ui-static|op-wstatic/i.test(href)) {
    return 'op';
  }

  if (/rc\./i.test(href) || /rc-/i.test(href)) {
    return 'rc';
  }

  return 'live';
};

export default network;
